import React from "react";
import Title from "../layouts/Title";
import {
  algoart,
  movienest,
  priceradar,
  projectThree,
} from "../../assets/index";
import ProjectsCard from "./ProjectsCard";

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="MovieNest"
          des="An intelligent movie curator that reads the room – literally. Combines real-time weather data and time context to recommend the perfect film for your current vibe, from rainy-night thrillers to sunny-morning comedies."
          githubLink="https://github.com/Shravan250/MovieNest"
          liveLink="https://shravandev.com/movienest"
          src={movienest}
        />
        <ProjectsCard
          title="PriceRadar"
          des="A Next.js e-commerce price tracker app that uses data scraping, cron jobs, sending emails, deployment, and more to fetch real-time prices and keep you updated on market trends."
          githubLink="https://github.com/Shravan250/PriceRadar"
          liveLink="https://price-radar-five.vercel.app/"
          src={priceradar}
        />
        <ProjectsCard
          title="Algo Art"
          des="A comprehensive visualization tool for data structures and algorithms built with modern web technologies. Features interactive animations for arrays, linked lists, trees, graphs, and sorting algorithms with customizable speed controls and step-by-step execution."
          githubLink="https://github.com/Shravan250/DSA-Visualizer"
          liveLink="https://dsa-visualizer-nu.vercel.app"
          src={algoart}
        />
        <ProjectsCard
          title="git-typescript"
          des="This repository explores Git's inner workings by implementing fundamental commands like init, cat-file, hash-object, ls-tree, write-tree, commit-tree, and clone."
          src={projectThree}
          githubLink="https://github.com/Shravan250/git-typescript"
          liveLink="https://github.com/Shravan250/git-typescript"
        />
      </div>
    </section>
  );
};

export default Projects;
